<div class="container-fluid">
    <div class="row" >
        <div class="col-md-3 col-lg-2">
            <div class="form-group">
                <label>Market<span>{{markets.filter(filterBy).length}}</span></label>
                <app-dropdown [list]="markets" name="market" placeholder="Select Market" (itemChange)="marketChange($event)"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2">
            <div class="form-group">
                <label>Sub - Market<span>{{subMarkets.filter(filterBy).length}}</span></label>
                <app-dropdown #subMarket [list]="subMarkets" name="subMarket" placeholder="Select Sub-Market" (itemChange)="subMarketChange($event)"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2" [hidden]="getClientVisibility">
            <div class="form-group">
                <label>Client<span>{{clients.filter(filterBy).length}}</span></label>
                <app-dropdown #client [list]="clients" name="client" placeholder="Select Client"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2" [hidden]="getReportSourceVisibility">
            <div class="form-group">
                <label>Report Source<span>{{globalStore.reportSource.filter(filterBy).length}}</span></label>
                <app-dropdown [list]="globalStore.reportSource" name="report" placeholder="Select" isSingleSelect="true" (itemChange)="reportSourceChange($event.item.name)"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2" [hidden]="getReportSource2Visibility">
            <div class="form-group">
                <label>Report Source<span>{{reportSource.filter(filterBy).length}}</span></label>
                <app-dropdown [list]="reportSource2" name="report"  placeholder="Select"  isSingleSelect="true" ></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2" [hidden]="getMonthsVisibility">
            <div class="form-group">
                <label>Month<span>{{months.filter(filterBy).length}}</span></label>
                <app-dropdown [list]="months" name="month" placeholder="Select Month"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2">
            <button type="button" class="ct-btn tertiary-btn" (click)="onSearchClick()" [disabled]="isFilterEmpty">Apply</button>
        </div>
    </div>
</div>